import { toast, ToastOptions } from 'react-toastify';
import styles from './notify-user.scss';

// eslint:disable-next-line:prefer-const
let options: ToastOptions = {
  autoClose: 5000,
  icon: false
};

/**
 * Displays a toast notification with a default visibility duration of 5 seconds
 */
export const notifyUser = {

  set: (explicitOptions: ToastOptions) => {
    options = explicitOptions;
    return notifyUser;
  },

  info: (message: JSX.Element | string) => toast(message, {
    className: styles.info,
    bodyClassName: styles.body,
    progressClassName: styles.progress,
    render: message,
    type: toast.TYPE.INFO,
    position: toast.POSITION.TOP_LEFT,
    zIndex: '2001',
    ...options
  } as any),

  success: (message: string) => toast(message, {
    type: toast.TYPE.SUCCESS,
    position: toast.POSITION.TOP_LEFT,
    zIndex: '2001',
    ...options
  } as any),

  error: (message: string) => toast(message, {
    type: toast.TYPE.ERROR,
    position: toast.POSITION.TOP_LEFT,
    zIndex: '2001',
    ...options
  } as any)
};
